import React, { useState } from 'react'

import { Chip } from '@clientbase/clientbase-library'

import { theme } from 'styles/theme'

export interface ChipTagData {
  id: string
  name: string
  color?: string
}

export interface ChipTagProps {
  tag: ChipTagData
  onDelete?: (tagId: string) => void
  sx?: object
  editMode?: boolean
  hoverDelete?: boolean
  // New context-aware props
  showDeleteButton?: boolean
  deleteContext?: 'details' | 'form'
  onDeleteImmediate?: (tagId: string) => void
}

const ChipTag: React.FC<ChipTagProps> = ({
  tag,
  onDelete,
  sx = {},
  editMode = false,
  hoverDelete = false,
  // New context-aware props with defaults
  showDeleteButton,
  deleteContext = 'form',
  onDeleteImmediate
}) => {
  const [isHovered, setIsHovered] = useState(false)

  // Garantir que a cor tenha o # se necessário
  const tagColor =
    tag.color && !tag.color.startsWith('#')
      ? `#${tag.color}`
      : tag.color || theme.palette.neutral[700]

  // Estilos base para tags
  const baseStyles = {
    backgroundColor: tagColor,
    color: theme.palette.neutral[200],
    fontWeight: 600,
    transition: 'all 0.2s ease',
    ...sx
  }

  // Enhanced logic for determining when to show delete button
  const shouldShowDelete = (() => {
    // If showDeleteButton is explicitly provided (true or false), use it
    if (showDeleteButton === true) {
      return true
    }
    if (showDeleteButton === false) {
      return false
    }

    // Backward compatibility: existing logic when showDeleteButton is undefined
    return onDelete && (editMode || (hoverDelete && isHovered))
  })()

  // Enhanced delete handler with context awareness
  const handleDelete = () => {
    if (deleteContext === 'details' && onDeleteImmediate) {
      // Details context: call immediate API deletion
      onDeleteImmediate(tag.id)
    } else if (deleteContext === 'form' && onDelete) {
      // Form context: local state removal
      onDelete(tag.id)
    } else if (onDelete) {
      // Fallback to existing behavior for backward compatibility
      onDelete(tag.id)
    }
  }

  return (
    <Chip
      variant="payment"
      label={tag.name}
      //size={size}
      onDelete={shouldShowDelete ? handleDelete : undefined}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={baseStyles}
    />
  )
}

export default ChipTag
